import actions from '../actions/interface';
import mutations from '../mutations/interface';
import getters from '../getters/interface';

const state = {
    path: 'school',
    selectTab: 'school',
    title: '学院',
    payStatus: {
        refuse: '已拒绝',
        accept: '已审核',
        paying: '已打款',
        paySure: '已打款',
        apply: '已申请',
        userSure: '已收款'
    },
    menuTypes: {
        school: '学院',
        bill: '订单',
        message: '消息',
        user: '个人中心',
        reflash: '刷新',
        balance: '余额',
        blocking: '冻结',
        usable: '可提现',
        score: '我的积分',
        totalScore: '总积分',
        direct: '努力',
        indirect: '躺赚',
        currency: '元',
        rank: '本周排名',
        profit: '我的战绩',
        totalProfit: '总战绩',
        retail: '零售',
        team: '团队',
        fans: '粉丝',
        member: '我的会员',
        totalMember: '总会员',
        chanel: '分享推荐',
        editAvatar: '编辑头像',
        userNamePlaceHolder: '输入/修改名字',
        userPasswordPlaceHolder: '输入/修改个性签名',
        clickToUpload: '点击上传',
        WxQrcodeCard: '微信名片二维码',
        toolTip: '提示',
        userEditTooltip: '上传自己的微信名片二维码方便别人找到自己 我们只会把你二维码显示给你的团队查询',
        save: '保存'
    },
    // 'retail' 'team' 'fans'
    selectMemberType: 'retail',
    memberScoreType: ['直接推荐', '间接推荐', '三级推荐'],
    // day month week
    fansBy: 'day',
    // day month week
    rankBy: 'week',
    showFooter: true
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};


// WEBPACK FOOTER //
// ./src/store/interface.js